(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["akk-giftbox-grid"] && !Shopify.designMode) return;
  try {
    
  // Tab switching, as progressive enhancement: with JS off the first panel is
  // visible and the rest stay [hidden], so the section degrades to one grid
  // rather than to nothing.
  class AkkTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (this.tabs.length < 2) return;
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.select(this.tabs.indexOf(tab));
    };

    // Arrow keys move between tabs, which is what makes a tablist a tablist.
    onKeydown = (event) => {
      const current = this.tabs.indexOf(document.activeElement);
      if (current < 0) return;
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = current === last ? 0 : current + 1;
      if (event.key === 'ArrowLeft') next = current === 0 ? last : current - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    };

    select(index) {
      this.tabs.forEach((tab, i) => {
        const chosen = i === index;
        tab.setAttribute('aria-selected', String(chosen));
        tab.setAttribute('tabindex', chosen ? '0' : '-1');
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !chosen;
      });
    }
  }

  if (!customElements.get('akk-tabs')) customElements.define('akk-tabs', AkkTabs);

  // The markup is plain HTML so it renders without the element defined; upgrade
  // the wrapper in place once the class exists.
  document.querySelectorAll('.akk-tabs').forEach((el) => {
    if (el.closest('akk-tabs')) return;
    const host = document.createElement('akk-tabs');
    el.parentNode.insertBefore(host, el);
    host.appendChild(el);
    let sib = host.nextElementSibling;
    while (sib && sib.getAttribute('role') === 'tabpanel') {
      const next = sib.nextElementSibling;
      host.appendChild(sib);
      sib = next;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akk-product-rail"] && !Shopify.designMode) return;
  try {
    
  // Arrow buttons scroll the adjacent rail. Delegated from the document so it
  // works for however many rail sections a page happens to carry.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-akk-rail]');
    if (!button) return;
    const head = button.closest('.akk-rail__head');
    const rail = head && head.parentElement.querySelector('.akk-rail');
    if (!rail) return;
    const card = rail.firstElementChild;
    // Step by two cards, falling back to most of the viewport if the rail is
    // empty and there is no card to measure.
    const step = card ? (card.getBoundingClientRect().width + 24) * 2 : rail.clientWidth * 0.8;
    rail.scrollBy({
      left: button.dataset.akkRail === 'prev' ? -step : step,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();
})();
